export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Von"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nach"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Betrag"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Überweisen"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Überweisung zwischen eigenen Konten"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Überweisungen innerhalb der Geldbörse"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Absender- und Empfängerkonten müssen unterschiedlich sein"])}
}